// App.jsx
import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero.jsx';
import Services from './components/Services.jsx';
//import Testimonials from './components/Testimonials.jsx';
import Footer from './components/Footer';
import IndustriesSection from './components/IndustriesSections.js';
import PomServiceSection from './components/PomServiceSection.jsx';
import Contact from './components/Contact.jsx';


export default function App() {
  return (
    <div className="min-h-screen font-sans text-gray-900 bg-white">
      <Navbar />
      <Hero />
      <Services />
      <IndustriesSection />
      <PomServiceSection />
      <Contact />
      <Footer />
    </div>
  );
}
